const Header = ({ isEditor }) => {
  return (
    <thead>
        <tr className="bg-gray-100 text-left">
            <th className="border border-gray-300 px-4 py-4 font-semibold">
                Nivel de la Comunidad
            </th>
            <th className="border border-gray-300 px-4 py-4 font-semibold">
                Rango de puntos acumulados
            </th>
            <th className="border border-gray-300 px-4 py-4 font-semibold">
                Ejemplos de actividades equivalentes
            </th>
            <th className="border border-gray-300 px-4 py-4 font-semibold">
                Tipo de beneficio
            </th>
            {isEditor &&
                <th className="border border-gray-300 px-4 py-4 font-semibold"></th>
            }
        </tr>
    </thead>
  );
};

export default Header;
